import React, { useMemo, useEffect, useState, useLayoutEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../../plugins/spinners.plugin";
import Button from "../../../../components/buttons/buttons";
import Table from "../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../components/skeleton/table";
import TableFilter from "../../../../components/tables/tableFilter";
import { Pagination } from "../../../../components/pagination/pagination";
import EmptyState from "../../../../assets/images/emptyState/food.svg";
import FilterFoodDropDown from "../../../../components/dropDown/filter/filterFood";
import { AllFiltersModal } from "../../../../components/modals/allFiltersModal";
import { getAllRewardsActionNoPagination } from "../../../../redux/reward/rewardActions";
import {
  getAllInfractionsAction,
  // filterInfractionsAction,
  searchInfractionsAction,
} from "../../../../redux/infraction/infractionActions";
import infractionType from "../../../../redux/infraction/infractionTypes";
import { writeFileWithXLSX } from "../../../../components/exports/xlsx";

export default function Approve() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { page } = useParams();

  const [isFilterOpen, setFilterState] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [data, setData] = useState([]);
  const [input, setInput] = useState({
    search: "",
  });
  const [payLoad] = useState({
    pagination: 1,
  });

  const { downloading } = useSelector((state) => state.reward);
  const { filtering } = useSelector((state) => state.reward);
  const { allInfractions, searching } = useSelector(
    (state) => state.infraction
  );

  useEffect(() => {
    dispatch(getAllInfractionsAction(1));
    // dispatch(filterInfractionsAction(payLoad, page));
    // eslint-disable-next-line
  }, [page]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((item, index) => {
        let show = {
          id: index + 1,
          outlet:
            item?.restaurant?.restaurant_name ??
            item?.store?.store_name ??
            "--",
          title: item?.title,
          message: item?.message,
          type: item?.type,
          date: item?.date,
          infractionData: item,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  function createTableDataDownload(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((reward, index) => {
        let show = {
          id: index + 1,
          outlet: reward.id,
          title: reward?.title,
          message: reward?.message,
          type: reward?.type,
          date: reward?.date,
        };
        outputArray.push(show);
        return true;
      });
      return outputArray;
    }
  }

  useLayoutEffect(() => {
    const dataSet = createTableData(allInfractions?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allInfractions]);

  function goToSinglePage(params) {
    let id = params?.show?.infractionData?.id;
    navigate(`/admin/infractions/single-infraction/${id}`, {
      state: { reward: params?.show?.infractionData },
    });
  }

  function goToCreate() {
    navigate(`/admin/infractions/create`);
  }

  const handleDownload = async () => {
    const response = await dispatch(
      getAllRewardsActionNoPagination({
        management_approved: 1,
        pagination: 0,
      })
    );
    if (response) {
      const newData = createTableDataDownload(response?.data);
      writeFileWithXLSX(newData, {
        filename: "Approved_Rewards.xlsx",
        download: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
    setIsSearchOpen(true);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allInfractions?.data);
      setData(dataSet);
      setIsSearchOpen(false);
      dispatch({
        type: infractionType["SEARCH_INFRACTIONS"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchInfractionsAction(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "S/N",
            accessor: "show.id",
          },
          {
            Header: "Outlet",
            accessor: "show.outlet",
          },
          {
            Header: "Request Title",
            accessor: "show.title",
          },
          {
            Header: "Request Description",
            accessor: "show.message",
          },
          {
            Header: "Type",
            accessor: "show.type",
          },
          {
            Header: "Date",
            accessor: "show.date",
          },
        ],
      },
    ],
    []
  );
  return (
    <div>
      <TableFilter
        title={"Infraction"}
        results={allInfractions?.to}
        totalResults={allInfractions?.total}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        searchPlaceholder={"Search infraction"}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterFoodDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
      >
        <Button.Primary title={"+ Create Infraction"} onClick={goToCreate} />
        <Button.Secondary
          title={downloading ? <Beat color={"#CE2600"} /> : "Download CSV"}
          type="button"
          disabled={!data}
          onClick={handleDownload}
        />
      </TableFilter>

      <div className="border-b border-[#E4E4F3]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-4 px-3">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="py-36 text-center">
            <div className="flex justify-center">
              <img src={EmptyState} className="w-auto" alt="no data" />
            </div>
            <h3 className="mt-5 text-xl font-bold">Infractions</h3>
            <p className="mt-2 text-sm text-[#9CA3AF]">
              You do not have any infractions yet.
            </p>
          </div>
        )}

        {!isSearchOpen && (
          <Pagination data={allInfractions} route={"admin/infraction"} />
        )}
      </div>
    </div>
  );
}
